import React from 'react';
import classnames from 'classnames';

const CSS = require('./SubNavbar.less');

interface SubNavbarProps {
  transparent?: boolean;
  children: any;
}

function SubNavbar({ transparent, children }: SubNavbarProps) {
  if (!children) {
    return null;
  }

  return (
    <div className={CSS.subNavbarContainer}>
      <div className={classnames(CSS.subNavbar, { [CSS.subNavbarTransparent]: transparent })} >
        <div className={CSS.navbarFilters}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default SubNavbar;
